import type {Converter} from '../types'
import {BASE_FONT_SIZE, CANVAS_HEIGHT, CANVAS_WIDTH} from '../constants'

const px: Converter = ({value}) => {
    return value
}

const spx: Converter = ({value}) => {
    return value
}

const em: Converter = ({value}) => {
    return value * BASE_FONT_SIZE
}

const rem: Converter = ({value}) => {
    return value * BASE_FONT_SIZE
}

const vw: Converter = ({value}) => {
    return (value * CANVAS_WIDTH) / 100
}

const vh: Converter = ({value}) => {
    return (value * CANVAS_HEIGHT) / 100
}

const unset: Converter = () => {
    return 0
}

const siteWidthPercentage: Converter = ({value}) => {
    return (value * CANVAS_WIDTH) / 100
}

export {em, px, rem, spx, unset, vh, vw, siteWidthPercentage}
